import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConstantsService } from '../fidelidade/ConstantsService';
import { CardapioAnalyticsService } from '../analytics/cardapio-analytics.service';
import { Subscription } from 'rxjs';

declare var moment: any;

@Component({
  selector: 'app-insights2',
  templateUrl: './insights2.component.html',
  styleUrls: ['./insights2.component.scss']
})
export class Insights2Component implements OnInit, OnDestroy {
  empresa: any = {};
  status: 'carregando' | 'sem_projeto' | 'erro' | 'pronto' = 'carregando';
  carregando = false;
  erroMensagem = '';

  quickDateFilter: 'hoje' | '7dias' | '14dias' | '30dias' | '90dias' = '30dias';
  filtroInicio: Date;
  filtroFim: Date;
  periodos = [
    { valor: 'hoje', label: 'Hoje' },
    { valor: '7dias', label: '7 dias' },
    { valor: '14dias', label: '14 dias' },
    { valor: '30dias', label: '30 dias' },
    { valor: '90dias', label: '90 dias' }
  ];

  abaAtiva: 'visao' | 'tendencia' | 'cardapio' | 'origens' | 'diagnostico' = 'visao';
  readonly abas: Array<{ id: 'visao' | 'tendencia' | 'cardapio' | 'origens' | 'diagnostico'; label: string }> = [
    { id: 'visao', label: 'Visão geral' },
    { id: 'tendencia', label: 'Fluxo de clientes' },
    { id: 'cardapio', label: 'Cardápio' },
    { id: 'origens', label: 'Canais' },
    { id: 'diagnostico', label: 'Diagnóstico' }
  ];

  readonly amostraMinima = 30;

  // Payload
  analyticsResumo: any = {};
  resumoFunil: any = {};
  steps: any[] = [];
  comparativo: any = null;
  serieTemporal: any = {};
  produtos: any[] = [];
  campanhas: any = {};
  alertasBackend: any[] = [];
  metadados: any = {};

  // Derivados
  etapas: any[] = [];
  juntas: any[] = [];
  detalheVisualizacoes: string | null = null;
  leitura = { frase: '', apoio: '' };
  recomendacao = '';
  categoriasSerie: string[] = [];
  serieVisitas: number[] = [];
  seriePedidos: number[] = [];
  serieConversao: number[] = [];
  temSerieVisitas = false;
  temSerieConversao = false;
  fontes: any[] = [];
  fontesComVendas = false;
  canalDetalheNome: string | null = null;
  heroVars: any = { visitas: null, pedidos: null, conversao: null };
  alertas: Array<{ titulo: string; descricao: string; tom: 'atencao' | 'erro' | 'neutro' }> = [];
  buscaProduto = '';
  paginaProdutos = 1;
  readonly produtosPorPagina = 8;

  private sub: Subscription;

  constructor(
    private constantsService: ConstantsService,
    private analyticsService: CardapioAnalyticsService
  ) {}

  ngOnInit(): void {
    this.aplicarPreset('30dias');
    this.sub = this.constantsService.empresa$.subscribe((empresa: any) => {
      if (!empresa) return;
      this.empresa = empresa;
      this.status = 'carregando';
      this.carregue();
    });
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }

  selecioneAba(id: 'visao' | 'tendencia' | 'cardapio' | 'origens' | 'diagnostico'): void {
    this.abaAtiva = id;
  }

  selecionePreset(preset: string): void {
    this.quickDateFilter = preset as any;
    this.aplicarPreset(preset);
    this.carregue();
  }

  private aplicarPreset(preset: string): void {
    const dias: any = { hoje: 0, '7dias': 6, '14dias': 13, '30dias': 29, '90dias': 89 };
    const n = dias[preset] != null ? dias[preset] : 29;
    this.filtroInicio = moment().subtract(n, 'days').startOf('day').toDate();
    this.filtroFim = moment().endOf('day').toDate();
  }

  obtenhaLabelPeriodo(): string {
    const mapa: any = { hoje: 'Hoje', '7dias': 'Últimos 7 dias', '14dias': 'Últimos 14 dias', '30dias': 'Últimos 30 dias', '90dias': 'Últimos 90 dias' };
    return mapa[this.quickDateFilter] || 'Últimos 30 dias';
  }

  obtenhaIntervaloDatas(): string {
    const inicio = moment(this.filtroInicio);
    const fim = moment(this.filtroFim);
    if (!inicio.isValid() || !fim.isValid()) return '';
    if (inicio.isSame(fim, 'day')) return inicio.format('DD/MM/YYYY');
    return `${inicio.format('DD/MM')} – ${fim.format('DD/MM/YYYY')}`;
  }

  formateMoeda(valor: number | null | undefined): string | null {
    if (valor == null || !Number.isFinite(Number(valor))) return null;
    return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  formateDuracao(segundos: number | null | undefined): string | null {
    if (segundos == null || !Number.isFinite(Number(segundos)) || segundos < 0) return null;
    const total = Math.round(Number(segundos));
    if (total < 60) return `${total}s`;
    const horas = Math.floor(total / 3600);
    const minutos = Math.floor((total % 3600) / 60);
    const restoSegundos = total % 60;
    if (horas > 0) return `${horas}h ${minutos}min`;
    return restoSegundos > 0 ? `${minutos}min ${restoSegundos}s` : `${minutos}min`;
  }

  obtenhaTemposEtapas(): Array<{ rotulo: string; icone: string; tempo: string | null; detalhe: string | null; amostra: number; variacao: string | null; variacaoClasse: string }> {
    const atuais = Array.isArray(this.analyticsResumo?.temposEtapas) ? this.analyticsResumo.temposEtapas : [];
    const anteriores = Array.isArray(this.analyticsResumo?.periodoAnterior?.temposEtapas)
      ? this.analyticsResumo.periodoAnterior.temposEtapas : [];
    const icones: any = {
      visita_visualizacao: 'fas fa-eye',
      visualizacao_sacola: 'fas fa-shopping-basket',
      sacola_checkout: 'far fa-credit-card',
      checkout_pedido: 'fas fa-check-circle'
    };

    return atuais.map((tempo: any) => {
      const anterior = anteriores.find((item: any) => item?.key === tempo?.key);
      let variacao: string | null = null;
      let variacaoClasse = 'neutra';

      if (tempo?.mediaSegundos != null && anterior?.mediaSegundos != null) {
        const diff = Number(tempo.mediaSegundos) - Number(anterior.mediaSegundos);
        if (Math.abs(diff) >= 1) {
          // Tempo menor entre etapas é bom: cliente flui mais rápido.
          variacao = `${diff > 0 ? '+' : '−'}${this.formateDuracao(Math.abs(diff))} vs. anterior`;
          variacaoClasse = diff > 0 ? 'negativa' : 'positiva';
        } else {
          variacao = 'igual ao anterior';
        }
      }

      const amostra = Number(tempo?.amostra || 0);
      const mediana = this.formateDuracao(tempo?.medianaSegundos);
      const detalhe = mediana && amostra > 0
        ? `mediana ${mediana} · ${amostra} ${amostra === 1 ? 'visita' : 'visitas'}`
        : null;

      return {
        rotulo: `${tempo?.de} → ${tempo?.para}`,
        icone: icones[tempo?.key] || 'far fa-clock',
        tempo: this.formateDuracao(tempo?.mediaSegundos),
        detalhe,
        amostra,
        variacao,
        variacaoClasse
      };
    });
  }

  temTemposEtapas(): boolean {
    return this.obtenhaTemposEtapas().some((tempo: any) => tempo.tempo != null);
  }

  // Linha do tempo até o pedido: medianas somadas por trecho, com o fechamento
  // (única parte que é do sistema) destacado dos trechos de decisão do cliente.
  obtenhaLinhaTempo(): any | null {
    const atuais = Array.isArray(this.analyticsResumo?.temposEtapas) ? this.analyticsResumo.temposEtapas : [];
    const ordem = [
      { key: 'visita_visualizacao', cor: '#94a6fb', icone: 'fas fa-eye' },
      { key: 'visualizacao_sacola', cor: '#6e62f0', icone: 'fas fa-shopping-bag' },
      { key: 'sacola_checkout', cor: '#4a30db', icone: 'fas fa-credit-card' },
      { key: 'checkout_pedido', cor: '#0fa96b', icone: 'fas fa-check-circle', fechamento: true }
    ];

    const segmentos: any[] = [];
    for (const ref of ordem) {
      const tempo = atuais.find((t: any) => t?.key === ref.key);
      const segundos = Number(tempo?.medianaSegundos != null ? tempo.medianaSegundos : tempo?.mediaSegundos);
      if (!tempo || !Number.isFinite(segundos) || segundos < 0) continue;
      segmentos.push({
        rotulo: `${tempo.de} → ${tempo.para}`,
        cor: ref.cor,
        icone: ref.icone,
        fechamento: !!ref.fechamento,
        segundos,
        amostra: Number(tempo?.amostra || 0)
      });
    }
    if (!segmentos.length) return null;

    const totalSegundos = segmentos.reduce((soma, seg) => soma + seg.segundos, 0);
    if (totalSegundos <= 0) return null;

    const maior = segmentos.reduce((a, b) => (b.segundos > a.segundos ? b : a));
    let acumulado = 0;
    for (const seg of segmentos) {
      acumulado += seg.segundos;
      seg.percent = (seg.segundos / totalSegundos) * 100;
      seg.fimPercent = (acumulado / totalSegundos) * 100;
      seg.acumulado = this.formateDuracao(acumulado);
      seg.tempo = this.formateDuracao(seg.segundos);
      seg.maior = segmentos.length > 1 && seg === maior;
      seg.mostraTick = seg.fimPercent >= 99.5 || (seg.percent >= 12 && seg.fimPercent <= 88);
    }

    const decisaoSegundos = segmentos.filter((s: any) => !s.fechamento).reduce((soma: number, seg: any) => soma + seg.segundos, 0);
    const fechamento = segmentos.find((s: any) => s.fechamento);
    const apoio = fechamento && decisaoSegundos > 0
      ? `${this.formateDuracao(decisaoSegundos)} escolhendo · pedido fechado em ${this.formateDuracao(fechamento.segundos)}`
      : 'da entrada no cardápio ao pedido concluído';

    const amostras = segmentos.map((s: any) => s.amostra).filter((n: number) => n > 0);
    let nota = 'Medianas por etapa';
    if (amostras.length) {
      const minimo = Math.min(...amostras);
      const maximo = Math.max(...amostras);
      nota += minimo === maximo
        ? ` · ${maximo} ${maximo === 1 ? 'visita' : 'visitas'} por trecho`
        : ` · ${minimo} a ${maximo} visitas por trecho`;
    }
    nota += '.';
    if (!this.temAmostraSuficiente()) nota += ' Abaixo do volume mínimo — tempos indicativos.';

    return { total: this.formateDuracao(totalSegundos), apoio, segmentos, nota };
  }

  obtenhaNovosVisitantes(): number | null {
    const valor = this.analyticsResumo?.novosVisitantes;
    return valor != null && Number.isFinite(Number(valor)) ? Math.max(0, Number(valor)) : null;
  }

  obtenhaVisitantesRecorrentes(): number | null {
    const valor = this.analyticsResumo?.visitantesRecorrentes;
    return valor != null && Number.isFinite(Number(valor)) ? Math.max(0, Number(valor)) : null;
  }

  obtenhaPercentualVisitantes(valor: number | null): number | null {
    const novos = this.obtenhaNovosVisitantes();
    const recorrentes = this.obtenhaVisitantesRecorrentes();
    if (valor == null || novos == null || recorrentes == null) return null;
    const total = novos + recorrentes;
    return total > 0 ? Math.min(100, (valor / total) * 100) : null;
  }

  obtenhaTextoAtualizacao(): string {
    const valor = this.metadados?.consultadoEm || this.metadados?.updatedAt || this.metadados?.atualizadoEm;
    const data = valor ? moment(valor) : null;
    if (!data || !data.isValid()) return 'atualizado recentemente';
    const minutos = Math.max(0, moment().diff(data, 'minutes'));
    return minutos < 1 ? 'atualizado agora' : `atualizado há ${minutos} min`;
  }

  async carregue(): Promise<void> {
    if (this.carregando) return;
    this.carregando = true;
    this.erroMensagem = '';

    try {
      const dados = await this.analyticsService.obtenhaDashboard({
        previous: true,
        interval: 'day',
        startDate: moment(this.filtroInicio).format('YYYY-MM-DD'),
        endDate: moment(this.filtroFim).format('YYYY-MM-DD')
      });

      if (dados?.metadados?.status === 'sem_projeto' || dados?.elegibilidade?.elegivel === false) {
        this.metadados = dados?.metadados || {};
        this.status = 'sem_projeto';
        return;
      }

      this.analyticsResumo = dados?.analytics || {};
      this.resumoFunil = dados?.resumo_funil || {};
      this.steps = this.resumoFunil.steps || [];
      this.comparativo = dados?.comparativo || null;
      this.serieTemporal = dados?.serie_temporal || {};
      this.produtos = dados?.produtos || [];
      this.campanhas = dados?.campanhas || {};
      this.alertasBackend = dados?.alertas || [];
      this.metadados = dados?.metadados || {};
      this.paginaProdutos = 1;

      this.calculeEtapas();
      this.calculeJuntas();
      this.calculeSeries();
      this.calculeFontes();
      this.calculeLeitura();
      this.calculeHeroVariacoes();
      this.calculeAlertas();
      this.status = 'pronto';
    } catch (erro: any) {
      this.erroMensagem = typeof erro === 'string' ? erro : 'Não foi possível carregar os dados.';
      if (this.status !== 'pronto') this.status = 'erro';
    } finally {
      this.carregando = false;
    }
  }

  // ---- Funil ----

  private calculeEtapas(): void {
    const referencias = [
      { key: 'visitas', label: 'Visitas', desc: 'entraram no cardápio', cor: '#94a6fb', corFinal: '#7c90f8' },
      { key: 'visualizacoes', label: 'Visualizou Produto', desc: 'abriram algum item', cor: '#7f82f7', corFinal: '#6a69f1' },
      { key: 'sacola', label: 'Sacola', desc: 'adicionaram itens', cor: '#6e62f0', corFinal: '#5a4be9' },
      { key: 'revisao', label: 'Fechamento', desc: 'começaram a fechar', cor: '#5d45e7', corFinal: '#4a30db' },
      { key: 'concluidos', label: 'Pedidos', desc: 'concluíram o pedido', cor: '#2fcb90', corFinal: '#0ea76a' }
    ];
    const stepsAnteriores = this.comparativo?.periodoAnterior?.steps;

    const contagens = referencias.map((ref: any, i: number) => {
      const st = (this.steps || []).find((s: any) => s?.key === ref.key) || this.steps[i];
      let count = Number(st?.count || 0);

      // Visualizou Produto: sessões únicas, na mesma base do percentual do funil.
      if (ref.key === 'visualizacoes') {
        const unicas = Number(this.analyticsResumo?.visualizacoesUnicas || 0);
        if (unicas > 0) count = unicas;
      }
      return { ref, st, count };
    });
    const base = Number(contagens[0]?.count || 0);

    // Percentual acumulado: produto das conversões etapa-a-etapa (cada uma ≤100%).
    // Em funil decrescente equivale a count/base; quando uma etapa do meio estoura a
    // base (mais eventos que visitas), o teto deixa de esconder queda posterior.
    let percentAcumulado = base > 0 ? 100 : 0;
    let countAnterior = base;
    this.etapas = contagens.map(({ ref, st, count }: any, i: number) => {
      if (i > 0) {
        percentAcumulado *= countAnterior > 0 ? Math.min(1, count / countAnterior) : 0;
        countAnterior = count;
      }
      const percent = percentAcumulado;

      let variacaoTexto: string | null = null;
      let variacaoClasse = 'neutra';
      const anterior = Array.isArray(stepsAnteriores)
        ? stepsAnteriores.find((s: any) => s?.key === ref.key || s?.event === st?.event)
        : null;
      const valorAnterior = Number(anterior?.count || 0);
      if (anterior && valorAnterior > 0) {
        const variacao = ((count - valorAnterior) / valorAnterior) * 100;
        if (Math.abs(variacao) < 0.05) {
          variacaoTexto = 'igual ao período anterior';
        } else {
          variacaoTexto = `${variacao > 0 ? '+' : '−'}${Math.abs(variacao).toFixed(0)}% vs. anterior`;
          variacaoClasse = variacao > 0 ? 'positiva' : 'negativa';
        }
      }

      return { ...ref, count, percent, variacaoTexto, variacaoClasse, detalhe: this.obtenhaDetalheEtapa(ref.key, st, count) };
    });

    const totalEventos = Number(this.analyticsResumo?.visualizacoes || 0);
    if (totalEventos > 0) {
      const partes = [`${totalEventos.toLocaleString('pt-BR')} ${totalEventos === 1 ? 'visualização' : 'visualizações'}`];
      if (base > 0) partes.push(`${(totalEventos / base).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}/visita`);
      this.detalheVisualizacoes = partes.join(' · ');
    } else {
      this.detalheVisualizacoes = null;
    }
  }

  // Chip de volume bruto quando a mesma sessão repetiu o evento da etapa
  private obtenhaDetalheEtapa(key: string, st: any, count: number): string | null {
    const eventos = Number(st?.eventCount || 0);
    if (eventos <= count) return null;

    if (key === 'sacola') {
      return `${eventos.toLocaleString('pt-BR')} adições de itens`;
    }

    if (key === 'revisao') {
      return `${eventos.toLocaleString('pt-BR')} aberturas do fechamento`;
    }

    return null;
  }

  // Mesmos ícones/cores dos trechos da linha do tempo, pela etapa de destino
  private readonly visuaisJuntas = [
    { icone: 'fas fa-eye', cor: '#94a6fb' },
    { icone: 'fas fa-shopping-bag', cor: '#6e62f0' },
    { icone: 'fas fa-credit-card', cor: '#4a30db' },
    { icone: 'fas fa-check-circle', cor: '#0fa96b' }
  ];

  private calculeJuntas(): void {
    const visuais = this.visuaisJuntas;
    const juntas: any[] = [];
    for (let i = 0; i < this.etapas.length - 1; i++) {
      const de = this.etapas[i];
      const para = this.etapas[i + 1];
      const percent = de.count > 0 ? Math.min(100, (para.count / de.count) * 100) : null;
      let saude = 'vazia';
      if (percent != null) saude = percent >= 70 ? 'boa' : (percent >= 40 ? 'media' : 'ruim');
      const visual = visuais[Math.min(i, visuais.length - 1)];
      juntas.push({
        de: de.label,
        para: para.label,
        deCount: de.count,
        paraCount: para.count,
        percent,
        saude,
        gargalo: false,
        icone: visual.icone,
        cor: visual.cor
      });
    }

    if (this.temAmostraSuficiente()) {
      const comDado = juntas.filter((j: any) => j.percent != null);
      if (comDado.length) {
        const pior = comDado.reduce((a: any, b: any) => (b.percent < a.percent ? b : a));
        if (pior.percent < 100) pior.gargalo = true;
      }
    }
    this.juntas = juntas;
  }

  temAmostraSuficiente(): boolean {
    return Number(this.etapas?.[0]?.count || 0) >= this.amostraMinima;
  }

  // ---- Onda do funil (etapas coladas, silhueta contínua) ----

  private obtenhaNiveisOnda(index: number): { esquerdo: number; direito: number; atual: number } {
    const total = this.etapas.length;
    const atual = Number(this.etapas?.[index]?.percent || 0);
    const anterior = index > 0 ? Number(this.etapas[index - 1]?.percent || 0) : atual;
    const proximo = index + 1 < total ? Number(this.etapas[index + 1]?.percent || 0) : atual;

    return {
      esquerdo: index === 0 ? atual : (anterior + atual) / 2,
      direito: index === total - 1 ? atual : (atual + proximo) / 2,
      atual
    };
  }

  obtenhaWavePath(index: number): string {
    const niveis = this.obtenhaNiveisOnda(index);
    const topoEsquerdo = Math.max(8, Math.min(86, 100 - niveis.esquerdo));
    const topoDireito = Math.max(8, Math.min(86, 100 - niveis.direito));
    return `M 0 100 L 0 ${topoEsquerdo} L 100 ${topoDireito} L 100 100 Z`;
  }

  obtenhaOffsetPercent(index: number): string {
    const niveis = this.obtenhaNiveisOnda(index);
    const nivelTexto = (niveis.esquerdo + niveis.atual + niveis.direito) / 3;
    const topo = 100 - nivelTexto;

    if (niveis.atual < 30) {
      return `${Math.max(20, Math.min(56, topo - 12))}%`;
    }
    return `${Math.max(32, Math.min(76, topo + (nivelTexto * 0.42)))}%`;
  }

  obtenhaClassePercent(index: number): 'claro' | 'escuro' {
    return Number(this.etapas?.[index]?.percent || 0) < 30 ? 'escuro' : 'claro';
  }

  obtenhaConversao(): number {
    const conversao = Number(this.resumoFunil?.conversion || 0);
    return Math.max(0, Math.min(100, Number.isFinite(conversao) ? conversao : 0));
  }

  obtenhaLive(): number {
    const live = Number(this.serieTemporal?.live || 0);
    return Number.isFinite(live) ? Math.max(0, live) : 0;
  }

  // ---- Leitura e recomendação ----

  private calculeLeitura(): void {
    const visitas = Number(this.etapas?.[0]?.count || 0);
    const pedidos = Number(this.etapas?.[4]?.count || 0);
    const conversao = this.obtenhaConversao().toFixed(1).replace('.', ',');

    if (visitas <= 0) {
      this.leitura = {
        frase: 'Sem visitas no período selecionado.',
        apoio: 'Compartilhe o link do cardápio nas redes e no WhatsApp para começar a medir.'
      };
      this.recomendacao = 'divulgue o link do cardápio para gerar as primeiras visitas.';
      return;
    }

    if (!this.temAmostraSuficiente()) {
      this.leitura = {
        frase: `${pedidos.toLocaleString('pt-BR')} de ${visitas.toLocaleString('pt-BR')} visitas ${pedidos === 1 ? 'virou' : 'viraram'} pedido — conversão de ${conversao}%.`,
        apoio: `Ainda são poucos dados para apontar um gargalo com confiança. O diagnóstico abre com ${this.amostraMinima} visitas no período.`
      };
      this.recomendacao = 'acompanhe o funil até haver volume suficiente para priorizar uma etapa.';
      return;
    }

    const pior = this.juntas.find((j: any) => j.gargalo);
    if (pior) {
      this.leitura = {
        frase: `Conversão de ${conversao}%. O funil perde mais gente entre ${pior.de} e ${pior.para}: só ${Number(pior.percent).toFixed(0)}% seguem adiante.`,
        apoio: this.obtenhaApoioComparativo()
      };
      this.recomendacao = `revise a passagem de ${pior.de} para ${pior.para} — é a menor continuidade do período.`;
      return;
    }

    this.leitura = {
      frase: `Conversão de ${conversao}% no período, sem gargalo evidente entre as etapas.`,
      apoio: this.obtenhaApoioComparativo()
    };
    this.recomendacao = 'mantenha o acompanhamento — o funil está fluindo sem perdas fora do padrão.';
  }

  private obtenhaApoioComparativo(): string {
    const anterior = this.comparativo?.periodoAnterior;
    if (!this.comparativo?.disponivel || !anterior || anterior.conversion == null) {
      return 'Sem período anterior comparável ainda.';
    }
    const diff = this.obtenhaConversao() - Number(anterior.conversion || 0);
    if (Math.abs(diff) < 0.05) return 'Conversão estável em relação ao período anterior.';
    return `${diff > 0 ? 'Alta' : 'Queda'} de ${Math.abs(diff).toFixed(1).replace('.', ',')} pontos vs. período anterior.`;
  }

  // ---- Séries ----

  private calculeSeries(): void {
    const series = this.serieTemporal?.series || [];
    this.categoriasSerie = series.map((s: any) => {
      const d = moment(s.date || s.day || s.label);
      return d.isValid() ? d.format('DD/MM') : '';
    });
    this.serieVisitas = series.map((s: any) => Math.max(0, Number(s?.visitors || s?.sessions || s?.count || 0)));
    this.seriePedidos = series.map((s: any) => Math.max(0, Number(s?.completed || s?.orders || 0)));
    this.serieConversao = series.map((s: any) => {
      const total = Number(s?.visitors || s?.sessions || s?.count || 0);
      const feitos = Number(s?.completed || s?.orders || 0);
      if (s?.conversion != null && Number.isFinite(Number(s.conversion))) return Number(s.conversion);
      return total > 0 ? Number(((feitos / total) * 100).toFixed(2)) : 0;
    });
    this.temSerieVisitas = this.serieVisitas.some((v: number) => v > 0);
    this.temSerieConversao = this.serieConversao.some((v: number) => v > 0);
  }

  obtenhaStepRotulos(): number {
    return Math.max(1, Math.ceil(this.categoriasSerie.length / 7));
  }

  // Sparkline inline (SVG 100x28) a partir da série diária real.
  obtenhaSparkline(serie: number[]): string | null {
    const dados = Array.isArray(serie) ? serie : [];
    if (dados.length < 2 || !dados.some((v: number) => v > 0)) return null;

    const maximo = Math.max(...dados, 1);
    const passo = 100 / (dados.length - 1);
    const pontos = dados.map((valor: number, i: number) => {
      const x = (i * passo).toFixed(1);
      const y = (26 - (Math.max(0, valor) / maximo) * 22).toFixed(1);
      return `${i === 0 ? 'M' : 'L'} ${x} ${y}`;
    });
    return pontos.join(' ');
  }

  obtenhaMaximoMovimento(): number {
    const maximo = Math.max(...this.serieVisitas, ...this.seriePedidos, 0);
    return maximo <= 10 ? 10 : Math.ceil(maximo / 10) * 10;
  }

  // Os 2–3 pontos que pedem ação agora, cada um apontando para a aba certa.
  obtenhaAtencaoAgora(): Array<{ titulo: string; descricao: string; tom: string; aba: 'visao' | 'tendencia' | 'cardapio' | 'origens' | 'diagnostico' }> {
    const itens: Array<{ titulo: string; descricao: string; tom: string; aba: any }> = [];

    const pior = this.juntas.find((j: any) => j.gargalo);
    if (pior) {
      itens.push({
        titulo: `Maior perda: ${pior.de} → ${pior.para}`,
        descricao: `Só ${Number(pior.percent).toFixed(0)}% seguem adiante — é onde o funil mais derrete.`,
        tom: 'ruim',
        aba: 'diagnostico'
      });
    }

    const sacolas = Number(this.etapas?.[2]?.count || 0);
    const pedidos = Number(this.etapas?.[4]?.count || 0);
    const perdidas = Math.max(0, sacolas - pedidos);
    if (perdidas > 0) {
      itens.push({
        titulo: `${perdidas.toLocaleString('pt-BR')} ${perdidas === 1 ? 'sacola parada' : 'sacolas paradas'}`,
        descricao: `${perdidas === 1 ? 'Um cliente montou' : 'Clientes montaram'} o pedido e não ${perdidas === 1 ? 'fechou' : 'fecharam'} — veja os produtos envolvidos.`,
        tom: 'media',
        aba: 'cardapio'
      });
    }

    for (const alerta of this.alertas) {
      if (itens.length >= 3) break;
      if (itens.some((item: any) => item.titulo === alerta.titulo)) continue;
      itens.push({
        titulo: alerta.titulo,
        descricao: alerta.descricao,
        tom: alerta.tom === 'neutro' ? 'neutra' : 'media',
        aba: 'diagnostico'
      });
    }

    return itens.slice(0, 3);
  }

  obtenhaMaximoVisitas(): number {
    const maximo = Math.max(...this.serieVisitas, 0);
    return maximo <= 10 ? 10 : Math.ceil(maximo / 10) * 10;
  }

  obtenhaMaximoConversao(): number {
    const maximo = Math.max(...this.serieConversao, 0);
    if (maximo <= 5) return 5;
    if (maximo <= 10) return 10;
    if (maximo <= 25) return 25;
    if (maximo <= 50) return 50;
    return 100;
  }

  // ---- Origens ----

  private calculeFontes(): void {
    const canais = Array.isArray(this.campanhas?.canais) ? this.campanhas.canais : [];

    if (canais.length) {
      const contagemOuNulo = (valor: any): number | null => valor == null ? null : Math.max(0, Number(valor) || 0);
      const lista = canais.map((item: any) => ({
        nome: String(item?.nome || item?.key || 'Não identificado').trim() || 'Não identificado',
        contagem: Math.max(0, Number(item?.visitas || 0) || 0),
        visualizacoes: contagemOuNulo(item?.visualizacoes),
        sacola: contagemOuNulo(item?.sacola),
        fechamento: contagemOuNulo(item?.fechamento),
        pedidos: Math.max(0, Number(item?.vendas || 0) || 0),
        receita: Number.isFinite(Number(item?.receita)) && item?.receita != null ? Number(item.receita) : null,
        ticketMedio: Number.isFinite(Number(item?.ticketMedio)) && item?.ticketMedio != null ? Number(item.ticketMedio) : null,
        pedidosComValor: Math.max(0, Number(item?.pedidosComValor || 0) || 0)
      }));
      const total = lista.reduce((soma: number, item: any) => soma + item.contagem, 0);

      this.fontes = lista
        .sort((a: any, b: any) => b.contagem - a.contagem)
        .map((item: any) => ({
          ...item,
          share: total > 0 ? (item.contagem / total) * 100 : 0,
          conversao: item.contagem > 0 ? (item.pedidos / item.contagem) * 100 : null,
          icone: this.obtenhaIconeFonte(item.nome),
          classe: this.obtenhaClasseFonte(item.nome)
        }));
      this.fontesComVendas = true;
      return;
    }

    const source = Array.isArray(this.campanhas?.source) ? this.campanhas.source : [];
    const referrer = Array.isArray(this.campanhas?.referrer) ? this.campanhas.referrer : [];
    const lista = (source.length ? source : referrer).map((item: any) => ({
      nome: String(item?.name || item?.label || item?.key || item?.value || 'Não identificado').trim() || 'Não identificado',
      contagem: Math.max(0, Number(item?.count || item?.sessions || item?.visitors || item?.value || 0) || 0)
    }));
    const total = lista.reduce((soma: number, item: any) => soma + item.contagem, 0);

    this.fontes = lista
      .sort((a: any, b: any) => b.contagem - a.contagem)
      .map((item: any) => ({
        ...item,
        share: total > 0 ? (item.contagem / total) * 100 : 0,
        icone: this.obtenhaIconeFonte(item.nome),
        classe: this.obtenhaClasseFonte(item.nome)
      }));
    this.fontesComVendas = false;
  }

  obtenhaKpisCanais(): Array<{ classe: string; icone: string; label: string; valor: string; nota: string }> {
    const a = this.analyticsResumo || {};
    const receita = this.formateMoeda(a.receita);
    const ticket = this.formateMoeda(a.ticketMedio);
    const pedidos = Number(a.pedidosConcluidos || this.resumoFunil?.completed || 0);

    return [
      { classe: 'roxo', icone: 'fas fa-dollar-sign', label: 'Receita atribuída', valor: receita || '—', nota: receita ? 'no período' : 'Em instrumentação' },
      { classe: 'azul', icone: 'fas fa-shopping-bag', label: 'Pedidos', valor: pedidos.toLocaleString('pt-BR'), nota: 'no período' },
      { classe: 'verde', icone: 'fas fa-chart-line', label: 'Conversão', valor: `${this.obtenhaConversao().toFixed(1).replace('.', ',')}%`, nota: 'sobre visitas' },
      { classe: 'laranja', icone: 'fas fa-ticket-alt', label: 'Ticket médio', valor: ticket || '—', nota: ticket ? 'por pedido com valor' : 'Em instrumentação' }
    ];
  }

  selecioneFonte(fonte: any): void {
    this.canalDetalheNome = fonte?.nome || null;
  }

  obtenhaFonteDetalhe(): any {
    if (!this.fontes.length) return null;
    return this.fontes.find((fonte: any) => fonte.nome === this.canalDetalheNome) || this.fontes[0];
  }

  // Funil do canal no mesmo formato das juntas da visão geral
  obtenhaPassagensFonte(fonte: any): any[] {
    if (!fonte || fonte.visualizacoes == null || fonte.sacola == null || fonte.fechamento == null) return [];

    const etapas = [
      { label: 'Visitas', count: Number(fonte.contagem || 0) },
      { label: 'Visualizações', count: Number(fonte.visualizacoes || 0) },
      { label: 'Sacola', count: Number(fonte.sacola || 0) },
      { label: 'Fechamento', count: Number(fonte.fechamento || 0) },
      { label: 'Pedidos', count: Number(fonte.pedidos || 0) }
    ];

    const passagens: any[] = [];
    for (let i = 0; i < etapas.length - 1; i++) {
      const de = etapas[i];
      const para = etapas[i + 1];
      const percent = de.count > 0 ? Math.min(100, (para.count / de.count) * 100) : null;
      const visual = this.visuaisJuntas[Math.min(i, this.visuaisJuntas.length - 1)];
      passagens.push({
        de: de.label,
        para: para.label,
        deCount: de.count,
        paraCount: para.count,
        percent,
        saude: percent == null ? 'vazia' : (percent >= 70 ? 'boa' : (percent >= 40 ? 'media' : 'ruim')),
        icone: visual.icone,
        cor: visual.cor
      });
    }
    return passagens;
  }

  obtenhaLiderCanais(): any {
    if (!this.fontes.length) return null;
    if (this.fontesComVendas) {
      const comReceita = this.fontes.filter((f: any) => Number(f.receita || 0) > 0);
      if (comReceita.length) {
        return comReceita.reduce((a: any, b: any) => (Number(b.receita) > Number(a.receita) ? b : a));
      }
    }
    return this.fontes[0];
  }

  obtenhaCoberturaReceita(): { comValor: number; pedidos: number } | null {
    if (!this.fontesComVendas) return null;
    const pedidos = this.fontes.reduce((soma: number, f: any) => soma + Number(f.pedidos || 0), 0);
    const comValor = this.fontes.reduce((soma: number, f: any) => soma + Number(f.pedidosComValor || 0), 0);
    if (!pedidos || comValor >= pedidos) return null;
    return { comValor, pedidos };
  }

  private obtenhaIconeFonte(nome: string): string {
    const n = this.normalize(nome);
    if (n.includes('instagram')) return 'fab fa-instagram';
    if (n.includes('facebook') || n === 'fb') return 'fab fa-facebook-f';
    if (n.includes('google')) return 'fab fa-google';
    if (n.includes('whatsapp') || n.includes('wa.me')) return 'fab fa-whatsapp';
    if (n.includes('direto') || n.includes('direct') || n === '(none)') return 'fas fa-compass';
    return 'fas fa-link';
  }

  private obtenhaClasseFonte(nome: string): string {
    const n = this.normalize(nome);
    if (n.includes('instagram')) return 'instagram';
    if (n.includes('facebook') || n === 'fb') return 'facebook';
    if (n.includes('google')) return 'google';
    if (n.includes('whatsapp') || n.includes('wa.me')) return 'whatsapp';
    return 'outro';
  }

  // ---- Produtos ----

  filtreProdutos(valor: string): void {
    this.buscaProduto = String(valor || '');
    this.paginaProdutos = 1;
  }

  obtenhaProdutosFiltrados(): any[] {
    const busca = this.normalize(this.buscaProduto);
    if (!busca) return this.produtos;
    return this.produtos.filter((p: any) => this.normalize(`${p?.title || ''} ${p?.path || ''}`).includes(busca));
  }

  obtenhaProdutosPaginados(): any[] {
    const inicio = (this.paginaProdutos - 1) * this.produtosPorPagina;
    return this.obtenhaProdutosFiltrados().slice(inicio, inicio + this.produtosPorPagina);
  }

  obtenhaTotalPaginas(): number {
    return Math.max(1, Math.ceil(this.obtenhaProdutosFiltrados().length / this.produtosPorPagina));
  }

  selecionePagina(pagina: number): void {
    this.paginaProdutos = Math.max(1, Math.min(this.obtenhaTotalPaginas(), Number(pagina || 1)));
  }

  obtenhaIntervaloProdutos(): string {
    const total = this.obtenhaProdutosFiltrados().length;
    if (!total) return 'Nenhum produto';
    const inicio = ((this.paginaProdutos - 1) * this.produtosPorPagina) + 1;
    const fim = Math.min(total, inicio + this.produtosPorPagina - 1);
    return `${inicio}–${fim} de ${total}`;
  }

  obtenhaTaxaSacola(produto: any): number | null {
    if (Number(produto?.uniqueViews || produto?.views || 0) <= 0) return null;
    const taxa = Number(produto?.addToCartRate || 0);
    return Math.max(0, Math.min(100, Number.isFinite(taxa) ? taxa : 0));
  }

  obtenhaTaxaPedido(produto: any): number | null {
    const viram = Number(produto?.uniqueViews || produto?.views || 0);
    if (viram <= 0) return null;
    return Math.max(0, Math.min(100, (Number(produto?.pedidos || 0) / viram) * 100));
  }

  readonly gruposRanking = [
    { titulo: 'Mais vistos', campo: 'views' },
    { titulo: 'Mais adicionados', campo: 'addToCart' },
    { titulo: 'Mais pedidos', campo: 'pedidos' }
  ];

  obtenhaInicial(produto: any): string {
    const titulo = String(produto?.title || '').trim();
    return titulo ? titulo.charAt(0).toUpperCase() : '?';
  }

  // ---- Diagnóstico ----

  private calculeAlertas(): void {
    const alertas: Array<{ titulo: string; descricao: string; tom: 'atencao' | 'erro' | 'neutro' }> = (this.alertasBackend || [])
      .filter((a: any) => this.temAmostraSuficiente() || !['maior_perda_funil', 'queda_conversao'].includes(a?.codigo))
      .slice(0, 3)
      .map((a: any) => ({
        titulo: a?.titulo || 'Alerta do período',
        descricao: a?.descricao || 'Há um ponto do funil que merece atenção.',
        tom: 'atencao'
      }));

    if (!this.temAmostraSuficiente() && !alertas.length) {
      const visitas = Number(this.etapas?.[0]?.count || 0);
      alertas.push({
        titulo: 'Amostra pequena',
        descricao: `${visitas.toLocaleString('pt-BR')} ${visitas === 1 ? 'visita' : 'visitas'} no início do funil — o mínimo para diagnóstico é ${this.amostraMinima}.`,
        tom: 'neutro'
      });
    }
    alertas.push({
      titulo: 'Erros de fechamento em instrumentação',
      descricao: 'Falhas de endereço, pagamento e envio ainda não aparecem neste relatório.',
      tom: 'neutro'
    });
    this.alertas = alertas.slice(0, 3);
  }

  obtenhaProgressoAmostra(): number {
    const visitas = Number(this.etapas?.[0]?.count || 0);
    return Math.max(0, Math.min(100, (visitas / this.amostraMinima) * 100));
  }

  // ---- Variações do hero e métricas secundárias ----

  private calculeHeroVariacoes(): void {
    this.heroVars = { visitas: null, pedidos: null, conversao: null };
    const anterior = this.comparativo?.periodoAnterior;
    if (!this.comparativo?.disponivel || !anterior) return;

    const stepsAnteriores = Array.isArray(anterior.steps) ? anterior.steps : [];
    const visitasAntes = Number(
      (stepsAnteriores.find((s: any) => s?.key === 'visitas') || {}).count ?? anterior.total ?? 0
    );
    const pedidosAntes = Number(
      (stepsAnteriores.find((s: any) => s?.key === 'concluidos') || {}).count ?? anterior.completed ?? 0
    );

    this.heroVars.visitas = this.formateVariacao(Number(this.etapas?.[0]?.count || 0), visitasAntes);
    this.heroVars.pedidos = this.formateVariacao(Number(this.etapas?.[4]?.count || 0), pedidosAntes);

    if (anterior.conversion != null) {
      const diff = this.obtenhaConversao() - Number(anterior.conversion || 0);
      if (Math.abs(diff) < 0.05) {
        this.heroVars.conversao = { texto: 'estável', classe: 'neutra' };
      } else {
        this.heroVars.conversao = {
          texto: `${diff > 0 ? '+' : '−'}${Math.abs(diff).toFixed(1).replace('.', ',')} pp`,
          classe: diff > 0 ? 'positiva' : 'negativa'
        };
      }
    }
  }

  private formateVariacao(atual: number, anterior: number): any {
    if (anterior <= 0) return atual > 0 ? { texto: 'novo no período', classe: 'neutra' } : null;
    const variacao = ((atual - anterior) / anterior) * 100;
    if (Math.abs(variacao) < 0.05) return { texto: 'igual ao anterior', classe: 'neutra' };
    return {
      texto: `${variacao > 0 ? '+' : '−'}${Math.abs(variacao).toFixed(0)}% vs. anterior`,
      classe: variacao > 0 ? 'positiva' : 'negativa'
    };
  }

  // ---- Cards do dono: um card por pergunta que o lojista realmente faz ----

  obtenhaCardsDono(): Array<{ rotulo: string; valor: string; detalhe: string; tom?: string; texto?: boolean }> {
    const visitas = Number(this.etapas?.[0]?.count || 0);
    const sacolas = Number(this.etapas?.[2]?.count || 0);
    const pedidos = Number(this.etapas?.[4]?.count || 0);

    const cards: Array<{ rotulo: string; valor: string; detalhe: string; tom?: string; texto?: boolean }> = [];

    const receita = this.formateMoeda(this.analyticsResumo?.receita);
    const ticket = this.formateMoeda(this.analyticsResumo?.ticketMedio);
    if (receita) {
      cards.push({ rotulo: 'Vendas', valor: receita, detalhe: ticket ? `ticket médio de ${ticket}` : 'pelo cardápio no período', verde: true } as any);
    } else {
      cards.push({ rotulo: 'Vendas', valor: '—', detalhe: pedidos > 0 ? 'pedidos sem valor no evento — aguardando dados novos' : 'sem pedidos no período', tom: 'neutra' });
    }

    cards.push({
      rotulo: 'Pedidos',
      valor: pedidos.toLocaleString('pt-BR'),
      detalhe: this.heroVars?.pedidos?.texto || 'sem período anterior comparável',
      tom: this.heroVars?.pedidos?.classe || 'neutra',
      spark: this.obtenhaSparkline(this.seriePedidos),
      sparkCor: '#0fa96b'
    } as any);

    cards.push({
      rotulo: 'Visitas ao cardápio',
      valor: visitas.toLocaleString('pt-BR'),
      detalhe: this.heroVars?.visitas?.texto || 'sem período anterior comparável',
      tom: this.heroVars?.visitas?.classe || 'neutra',
      spark: this.obtenhaSparkline(this.serieVisitas),
      sparkCor: '#5b4bed'
    } as any);

    if (visitas > 0) {
      const dezena = Math.round(this.obtenhaConversao() / 10);
      const varConversao = this.heroVars?.conversao;
      cards.push({
        rotulo: 'De cada 10 visitas',
        valor: dezena < 1 ? '<1' : `≈${dezena}`,
        detalhe: `${dezena === 1 ? 'vira pedido' : 'viram pedido'}${varConversao ? ' · ' + varConversao.texto : ''}`,
        tom: varConversao?.classe || 'neutra'
      });
    } else {
      cards.push({ rotulo: 'De cada 10 visitas', valor: '—', detalhe: 'sem visitas no período', tom: 'neutra' });
    }

    const perdidas = Math.max(0, sacolas - pedidos);
    cards.push({
      rotulo: 'Quase pediram',
      valor: perdidas.toLocaleString('pt-BR'),
      detalhe: perdidas === 0
        ? (sacolas > 0 ? 'nenhuma sacola ficou pelo caminho' : 'nenhuma sacola montada ainda')
        : (perdidas === 1 ? 'sacola não virou pedido' : 'sacolas não viraram pedido'),
      tom: perdidas > 0 ? 'negativa' : (sacolas > 0 ? 'positiva' : 'neutra')
    });

    const lider = this.obtenhaLiderPedidos();
    const maisVisto = this.obtenhaTopPor('views')[0];
    if (lider) {
      const n = Number(lider.pedidos || 0);
      cards.push({ rotulo: 'Campeão do período', valor: String(lider.title || '—'), detalhe: `${n.toLocaleString('pt-BR')} ${n === 1 ? 'pedido' : 'pedidos'}`, texto: true });
    } else if (maisVisto && Number(maisVisto.views || 0) > 0) {
      cards.push({ rotulo: 'Campeão do período', valor: String(maisVisto.title || '—'), detalhe: 'o mais visto · ainda sem pedidos', tom: 'neutra', texto: true });
    } else {
      cards.push({ rotulo: 'Campeão do período', valor: '—', detalhe: 'sem movimento nos produtos', tom: 'neutra' });
    }

    const fonte = this.fontes?.[0];
    if (fonte) {
      cards.push({
        rotulo: 'Quem traz gente',
        valor: String(fonte.nome),
        detalhe: `${Number(fonte.contagem).toLocaleString('pt-BR')} ${Number(fonte.contagem) === 1 ? 'visita' : 'visitas'} · ${Number(fonte.share).toFixed(0)}% do total`,
        texto: true
      });
    } else {
      cards.push({ rotulo: 'Quem traz gente', valor: '—', detalhe: 'nenhuma origem identificada', tom: 'neutra' });
    }

    const pico = this.obtenhaPicoVisitas();
    const temPico = pico.titulo !== 'Sem pico identificado';
    cards.push({
      rotulo: 'Seu dia forte',
      valor: temPico ? pico.titulo : '—',
      detalhe: temPico ? pico.descricao : 'ainda sem série diária',
      tom: temPico ? undefined : 'neutra',
      texto: temPico
    });

    return cards;
  }

  obtenhaMetricasSecundarias(): Array<{ label: string; texto: string; nota: string }> {
    const a = this.analyticsResumo || {};
    const receita = this.formateMoeda(a.receita);
    const ticket = this.formateMoeda(a.ticketMedio);

    return [
      { label: 'Sessões', texto: Number(a.sessoes || 0).toLocaleString('pt-BR'), nota: 'identificadas no período' },
      { label: 'Visitas únicas', texto: Number(a.visitasUnicas || 0).toLocaleString('pt-BR'), nota: 'sessões que entraram' },
      { label: 'Visualizações', texto: Number(a.visualizacoes || 0).toLocaleString('pt-BR'), nota: 'eventos de produto' },
      { label: 'Visualizações únicas', texto: Number(a.visualizacoesUnicas || 0).toLocaleString('pt-BR'), nota: 'sessões que viram' },
      { label: 'Ticket médio', texto: ticket || '—', nota: ticket ? 'por pedido com valor' : 'sem pedidos com valor' },
      { label: 'Receita', texto: receita || '—', nota: receita ? `${Number(a.pedidosComValor || 0)} ${Number(a.pedidosComValor || 0) === 1 ? 'pedido com valor' : 'pedidos com valor'}` : 'sem pedidos com valor' }
    ];
  }

  // ---- Comportamento ----

  obtenhaPicoVisitas(): { titulo: string; descricao: string } {
    const series = this.serieTemporal?.series || [];
    if (!series.length) return { titulo: 'Sem pico identificado', descricao: 'A série diária ainda não está disponível.' };
    const maior = [...series].sort((a: any, b: any) =>
      Number(b?.visitors || b?.sessions || b?.count || 0) - Number(a?.visitors || a?.sessions || a?.count || 0))[0];
    const visitas = Number(maior?.visitors || maior?.sessions || maior?.count || 0);
    if (visitas <= 0) return { titulo: 'Sem pico identificado', descricao: 'Nenhuma visita registrada na série diária.' };
    const data = moment(maior?.date || maior?.day || maior?.label);
    const dia = data.isValid() ? data.locale('pt-br').format('dddd (DD/MM)') : 'dia de maior movimento';
    return {
      titulo: `${dia.charAt(0).toUpperCase()}${dia.slice(1)}`,
      descricao: `${visitas.toLocaleString('pt-BR')} ${visitas === 1 ? 'visita' : 'visitas'} no maior pico do período.`
    };
  }

  readonly temposEtapas = ['Visita → viu produto', 'Viu produto → sacola', 'Sacola → fechamento', 'Fechamento → pedido'];

  // ---- Rankings ----

  obtenhaTopPor(campo: string): any[] {
    return [...this.produtos]
      .sort((a: any, b: any) => Number(b?.[campo] || 0) - Number(a?.[campo] || 0))
      .slice(0, 3);
  }

  obtenhaPercentualRanking(produto: any, lista: any[], campo: string): number {
    const maior = Math.max(...(lista || []).map((item: any) => Number(item?.[campo] || 0)), 0);
    const valor = Number(produto?.[campo] || 0);
    if (maior <= 0 || valor <= 0) return 0;
    return Math.max(0, Math.min(100, (valor / maior) * 100));
  }

  obtenhaLiderPedidos(): any | null {
    const top = this.obtenhaTopPor('pedidos');
    return top.length && Number(top[0]?.pedidos || 0) > 0 ? top[0] : null;
  }

  exportarCSV(tipo: string): void {
    const url = this.analyticsService.obtenhaUrlExportacao(tipo, {
      startDate: moment(this.filtroInicio).format('YYYY-MM-DD'),
      endDate: moment(this.filtroFim).format('YYYY-MM-DD')
    });
    window.open(url, '_blank');
  }

  private normalize(valor: string): string {
    return String(valor || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }
}
